import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import api from '../../services/api'
import { ITesouroWallet } from '../../store/modules/tesouroWallet/types'
import { IWallet, WalletType } from '../../store/modules/wallet/types'

// Add this new interface
export interface PersonalizedWallet {
  id: number;
  name: string;
  starting_value: number;
  current_value: number;
}

interface useWalletsProp {
  wallet_type?: WalletType
}

export const useWallets = (props?: useWalletsProp) => {
  const refetch = () => {
    stockWalletsQuery.refetch()
    tesouroWalletsQuery.refetch()
    personalizedWalletsQuery.refetch() // Add this line
  }

  const stockWalletsQuery = useQuery(['stockWallets'], async () => {
    try {
      const response = await api.get<IWallet[]>('/wallet/list');

      return response.data.map(wallet => ({
        ...wallet,
        type: WalletType['Ações, BDRs, ETFs Nacionais'],
        typeName: 'Ações, BDRs, ETFs Nacionais'
      }));
    } catch (err) {
      console.log(`Error getting user wallets: ${err}`)
      return []
    }
  })

  const tesouroWalletsQuery = useQuery(['tesouroWallets'], async () => {
    try {
      const response = await api.get<ITesouroWallet[]>('/tesouro/list');

      return response.data.map(wallet => ({
        ...wallet,
        type: WalletType['Tesouro Direto'],
        typeName: 'Tesouro Direto'
      }));
    } catch (err) {
      console.log(`Error getting user tresures: ${err}`)

      return []
    }
  })

  const personalizedWalletsQuery = useQuery(['personalizedWallets'], async () => {
    try {
      const response = await api.get<PersonalizedWallet[]>('/personalized-wallets');
      return response.data.map(wallet => ({
        ...wallet,
        type: WalletType['Personalizada'],
        typeName: 'Personalizada'
      }));
    } catch (err) {
      console.log(`Error getting personalized wallets: ${err}`)
      return []
    }
  })

  const data = useMemo(() => {
    const stockWallets = stockWalletsQuery.data?.filter((stockWallet) => {
      if (props?.wallet_type) {
        return stockWallet.type === props?.wallet_type
      }

      return true
    })

    const tesouroWallets = tesouroWalletsQuery.data?.filter((tesouroWallet) => {
      if (props?.wallet_type) {
        return tesouroWallet.type === props?.wallet_type
      }

      return true
    })

    const personalizedWallets = personalizedWalletsQuery.data?.filter((personalizedWallet) => {
      if (props?.wallet_type) {
        return personalizedWallet.type === props?.wallet_type
      }
      return true
    })

    return [
      ...stockWallets ?? [],
      ...tesouroWallets ?? [],
      ...personalizedWallets ?? [], // Add this line
    ]
  }, [stockWalletsQuery, tesouroWalletsQuery, personalizedWalletsQuery, props]) // Update dependencies

  const isLoading = stockWalletsQuery.isLoading || tesouroWalletsQuery.isLoading || personalizedWalletsQuery.isLoading
  const isFetching = stockWalletsQuery.isFetching || tesouroWalletsQuery.isFetching || personalizedWalletsQuery.isFetching
  const isError = stockWalletsQuery.isError || tesouroWalletsQuery.isError || personalizedWalletsQuery.isError

  return {
    data,
    isLoading,
    isFetching,
    isError,
    refetch,
  }
}
